export default "__VITE_ASSET__AifJQSxg__"